module.exports = __webpack_public_path__ + "static/media/mission.5b7a91f0.svg";